export const FONT_OPTIONS = ['Inter','Poppins','Roboto','Nunito','Manrope','Arial','Georgia','Times New Roman','Verdana','System UI'];
export const TABLE_DENSITY_OPTIONS = [
  {value:'compact',label:'Compact'},
  {value:'comfortable',label:'Comfortable'},
  {value:'spacious',label:'Spacious'},
];
export const RECEIPT_LAYOUT_OPTIONS = [
  {value:'table',label:'Table / Accounting Format'},
  {value:'two_column',label:'Two Column Details'},
  {value:'blocks',label:'Card / Block Layout'},
  {value:'traditional',label:'Traditional Receipt'},
  {value:'thermal',label:'Compact Thermal'},
  {value:'minimal',label:'Minimal Professional'},
];
export const BILLING_MODEL_OPTIONS = [
  {value:'monthly',label:'Monthly Subscription'},
  {value:'annual',label:'Annual Subscription'},
  {value:'one_time',label:'One-Time License'},
  {value:'per_student',label:'Per Student'},
  {value:'hybrid',label:'Hybrid Base + Per Student'},
];
export const AI_FEATURES = [
  ['studentInsights','Student 360 Insights'],
  ['academicRisk','Academic Risk Indicators'],
  ['progressSummary','Parent-friendly Progress Summary'],
  ['teacherInsights','Teacher 360 Insights'],
  ['attendanceAnomalies','Attendance Anomaly Detection'],
  ['smartSearch','Natural-language Smart Search'],
  ['reportExplanation','Report Explanation'],
  ['communicationAssistant','Communication Assistant'],
  ['admissionAssistant','Admission Application Assistant'],
  ['teachingAssistant','Lesson / Assignment Assistant'],
  ['dataQuality','Data Quality Assistant'],
];
